import {combineReducers} from "redux";
import * as ACTION from '../constants';


let loading = (state = false, action) => {
	let {type} = action;
	switch (type) {
		case  ACTION.UPDATE_WAREHOUSE.REQUEST:
			return true;
		case ACTION.UPDATE_WAREHOUSE.FAILED:
		case ACTION.UPDATE_WAREHOUSE.SUCCESS:
			return false;
		default:
			return state

	}
};
export default combineReducers({loading})
